export { GlobalStyles as default } from '@hg/stylizator/utils'
